import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HERO } from '@/constants/testIds';
import { Sparkles, ArrowRight, Loader2 } from 'lucide-react';
import api from '@/lib/api';

const examples = [
  'Energetic Punjabi wedding singer in Dubai under ₹2L',
  'Bollywood DJ for a luxury New Year party in Goa',
  'Contemporary dancer for OTT music video shoot in Mumbai',
  'Method-trained actor (male) for streaming series',
];

const AISearchBar = ({ onResult, large = true }) => {
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [exampleIdx, setExampleIdx] = useState(0);
  const navigate = useNavigate();

  React.useEffect(() => {
    const t = setInterval(() => setExampleIdx((i) => (i + 1) % examples.length), 3500);
    return () => clearInterval(t);
  }, []);

  const search = async (e) => {
    e?.preventDefault?.();
    if (!query.trim()) return;
    setLoading(true);
    try {
      if (onResult) {
        const { data } = await api.post('/ai/search', { query });
        onResult(data);
      } else {
        navigate(`/artists?ai=${encodeURIComponent(query)}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={search} className={`relative w-full ${large ? 'max-w-3xl' : 'max-w-2xl'} mx-auto`}>
      <div className="relative rounded-2xl glass-strong gradient-border p-1.5 shadow-[0_20px_60px_-20px_rgba(123,47,247,0.5)]">
        <div className="flex items-center">
          <div className="pl-5 pr-2 text-fuchsia-300">
            <Sparkles className="h-5 w-5" />
          </div>
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={`Try: "${examples[exampleIdx]}"`}
            data-testid={HERO.searchInput}
            className={`flex-1 bg-transparent ${large ? 'py-5 text-lg' : 'py-3.5 text-base'} px-2 text-white placeholder-slate-500 focus:outline-none font-body`}
          />
          <button
            type="submit"
            disabled={loading}
            data-testid={HERO.searchButton}
            className="btn-rainbow rounded-xl px-5 py-3 text-white font-medium flex items-center gap-2 mr-1.5 disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ArrowRight className="h-4 w-4" />}
            <span className="hidden sm:inline">{loading ? 'Thinking…' : 'Discover'}</span>
          </button>
        </div>
      </div>
      <p className="mt-3 text-xs text-slate-500 text-center tracking-wider uppercase">
        Powered by Claude Sonnet · Understands natural language
      </p>
    </form>
  );
};

export default AISearchBar;
